import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  canUploadToSchool: true, // For StudentsHeader
  canUploadToEvent: true,  // For EventsTabContent
};

const uploadPermissionsSlice = createSlice({
  name: "uploadPermissions",
  initialState,
  reducers: {
    setSchoolUploadPermission: (state, action) => {
      state.canUploadToSchool = action.payload;
    },
    setEventUploadPermission: (state, action) => {
      state.canUploadToEvent = action.payload;
    },
    resetUploadPermissions: (state) => {
      state.canUploadToSchool = true;
      state.canUploadToEvent = true;
    },
  },
});

export const { 
  setSchoolUploadPermission, 
  setEventUploadPermission, 
  resetUploadPermissions 
} = uploadPermissionsSlice.actions;

export default uploadPermissionsSlice.reducer;
